module.exports = __webpack_public_path__ + "static/media/dots.31e6113d.svg";